<template>
    <div ref="info" class="financial-info">
        <img :src="infoImg" alt="" @mouseenter="mouseIn" @mouseout="mouseOut">
        <div  v-if="tipStatus.price" class="amount-info">
            <div>
                <div class="title">
                    帳單服務費
                </div>
                <div class="amount">
                    {{toCurrency(data.billServiceFeeSum)}}
                </div>
            </div>
            <div>
                <div class="title">
                    記帳服務費
                </div>
                <div class="amount">
                    {{toCurrency(data.ledgerServiceFeeSum)}}
                </div>
            </div>
            <div>
                <div class="title">
                    押金存量
                </div>
                <div class="amount">
                    {{toCurrency(data.holdDepositSum)}}
                </div>
            </div>
            <div>
                <div class="title">
                    代墊收益
                </div>
                <div class="amount">
                    {{toCurrency(data.advanceIncomeSum)}}
                </div>
            </div>
            <div>
                <div class="title">
                    其他
                </div>
                <div class="amount">
                    {{toCurrency(data.otherSum)}}
                </div>
            </div>
        </div>
        <!-- <border-tips v-if="tipStatus.price" msg="報價說明文案報價說明文案報價說明文案。" width="117px"></border-tips> -->
    </div>
</template>

<script>
import borderTips from '@/components/bussiness/widges/tips/borderTips.vue';
export default {
    data () {
        return {
            show: 0,
            infoImg: require('@/assets/img/icon/info_gray.svg'),
            tipStatus: {
                price: false,
            },
        }
    },
    props: {
        data: Object,
    },
    methods: {
        mouseIn: function () {
            this.infoImg = require('@/assets/img/icon/info_blue.svg')
            this.tipStatus.price = true
            this.$refs.info.style.zIndex = 2
        },
        mouseOut: function () {
            this.infoImg = require('@/assets/img/icon/info_gray.svg')
            this.tipStatus.price = false
            this.$refs.info.style.zIndex = 1

        },
    },
    components: {
        borderTips
    }
}
</script>
<style lang="scss"  >
    .financial-info{
        position: absolute;
        top: 1px;
        right: -24px;
        z-index: 1;
        font-size: 14px;
        color: #292625;
        font-weight: normal;
        .amount-info{
            position: relative;
            left: 35px;
            box-shadow: 1px 3px 8px 0 rgba(3, 6, 52, 0.08);
            border: solid 1px #3942b5;
            background-color: #ffffff;
            padding: 12px 16px;
            border-radius: 4px;
            min-width: 206px;
            box-sizing: border-box;
            text-align: left;
            line-height: 1.7;
            >div{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 4px;
                .amount{
                    text-align: right;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tips/financialTipsHover.vue